import { VenueCategoryUnionType } from '@api';
import { AddressFields, FormActions } from '@common';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BaseInformationFields } from './components';

type VenueFormFieldsPropsType = {
  venueCategories: VenueCategoryUnionType[];
  onClose: () => void;
};
export const VenueFormFields: React.FC<VenueFormFieldsPropsType> = ({
  venueCategories,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Stack>
      <BaseInformationFields venueCategories={venueCategories} />
      <AddressFields.Root>
        <AddressFields.Street required />
        <AddressFields.Addition />
        <AddressFields.Zip required />
        <AddressFields.City required />
        <AddressFields.CityEnglish />
        <AddressFields.State required />
        <AddressFields.Country required />
      </AddressFields.Root>
      <FormActions
        onCancel={onClose}
        saveButtonText={t('SAVE_BUTTON')}
        cancelButtonText={t('CANCEL_BUTTON')}
      />
    </Stack>
  );
};
